import { make } from "vuex-pathify"
import PagesAPI from "@/api/pages"

const develPages = [
  {
    id: "101599238436468",
    name: "Devel page",
    picture: {
      data: {
        url: "",
      },
    },
  },
]

const state = () => {
  return {
    loading: false,
    pages: [],
  }
}

const actions = {
  clearModule({ commit }) {
    commit("CLEAR_MODULE")
  },

  loadPages({ commit, rootGetters, state }) {
    if (!state.pages.length) {
      commit("SET_LOADING", true)

      const businessId = rootGetters["accounts/businessId"]

      // commit("SET_PAGES", develPages)

      return PagesAPI.getBusinessPages(businessId)
        .then(response => {
          commit("SET_PAGES", response)
        })
        .finally(() => {
          commit("SET_LOADING", false)
        })
    }
  },
}

const getters = {
  ...make.getters(state),
  findPage: state => item => {
    const id = typeof item === "object" ? item.id : item

    return state.pages.find(i => i.id === id)
  },
}

const mutations = {
  ...make.mutations(state),
  CLEAR_MODULE(state) {
    state.loading = false
    state.pages = []
  },
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
